import $ from 'jquery';
import { U as Url } from './url.min.js';

/**
 * **THN Demo**
 *
 * @exports bs_228
 * @category engines
 */
function factory({ window, document, thn }) {
    const engine = {};
    /**
       * @memberOf module:bs_228
       * @see {@link language_check}
       *
       * @param {object} ctx - The context object.
       */
    engine.languageCheck = function languageCheck(ctx) {
        return new Promise(function (resolve, reject) {
            var lang = thn.parseUrlParameter('lang');
            if (lang && ctx.langs.test(lang)) {
                resolve(lang);
                return;
            }
            reject('no_language');
        });
    };
    /**
       * @memberOf module:bs_228
       * @see {@link is_user_logged}
       *
       * @param {object} ctx - The context object.
       */
    engine.isUserLogged = function isUserLogged(ctx) {
        return !thn.empty(thn.parseUrlParameter('user_logged'));
    };
    /**
       * @memberOf module:bs_228
       * @see {@link generate_search_url}
       *
       * @param {object} ctx - The context object.
       */
    engine.generateSearchUrl = function generateSearchUrl(ctx) {
        var url = new Url(ctx.baseUrl);
        // Consider any other URL outside thehotelsnetwork.com
        // as an invalid BE URL
        const thnHotelHost = url.host.match(/^hoteldemo\.thehotelsnetwork\.com\/?$/);
        const thnHotelRatesPath = url.path.match(/\/(tower|peacefulgarden|cocos)\/roomandrates.php$/);
        // Check if optional queryString params are in the URL
        // Adults: optional, buy if it exists, it must be [adults]
        const adults = !url.query.adults || url.query.adults === '[adults]';
        const children = !url.query.children || url.query.children === '[children]';
        /* Direct case: https://hoteldemo.thehotelsnetwork.com/tower/roomandrates.php?arrival=[date_begin]&departure=[date_end]&adults=[adults]&children=[children] */
        if (thnHotelHost && thnHotelRatesPath
            && url.query.arrival === '[date_begin]'
            && url.query.departure === '[date_end]'
            && adults
            && children) {
            ctx.newUrl = ctx.baseUrl;
        }
        else if (thnHotelHost && thnHotelRatesPath) {
            // Case 2: Format Query Params
            delete url.query.arrival;
            delete url.query.departure;
            delete url.query.adults;
            delete url.query.children;
            url.query.arrival = '[date_begin]';
            url.query.departure = '[date_end]';
            url.query.adults = '[adults]';
            url.query.children = '[children]';
            // export into ctx.new_url
            ctx.newUrl = url.decode(url.toString());
        }
        else {
            // Case 3: Not a valid URL. Return empty
            ctx.newUrl = '';
        }
        // Check dates
        if (thn.empty(ctx.newData.dateBegin)
            || thn.empty(ctx.newData.dateEnd)) {
            // invalid
            ctx.newUrl = '';
        }
        return ctx;
    };
    /**
       * @memberOf module:bs_228
       * @this thn.widgets.price
       * @see {@link Price#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceParseData = function priceParseData(ctx) {
        const widgetData = {};
        // Format dates
        const formatDates = (date) => date && date.replace(/(\d+)\D+(\d+)\D+(\d+)/, (_, day, month, year) => `${year}/${month.padStart(2, '0')}/${day.padStart(2, '0')}`);
        // Dates
        let dateBeginUrl = ((thn.parseUrlParameter('arrival') || '').match(/([0-9]{4})\D+([0-9]{1,2})\D+([0-9]{1,2})/g) || [])[0];
        dateBeginUrl = dateBeginUrl && dateBeginUrl.replace(/\D+/g, '/');
        const dateBeginDom = formatDates(document.querySelector('#checkin')?.value);
        let dateEndUrl = ((thn.parseUrlParameter('departure') || '').match(/([0-9]{4})\D+([0-9]{1,2})\D+([0-9]{1,2})/g) || [])[0];
        dateEndUrl = dateEndUrl && dateEndUrl.replace(/\D+/g, '/');
        const dateEndDom = formatDates(document.querySelector('#checkout')?.value);
        /* Adults + Children */
        const urlAdults = thn.parseNumber((thn.parseUrlParameter('adults')));
        const urlChildren = thn.parseNumber((thn.parseUrlParameter('children')));
        widgetData.dateBegin = dateBeginUrl || dateBeginDom;
        widgetData.dateEnd = dateEndUrl || dateEndDom;
        widgetData.adults = urlAdults || parseInt($('#adults').val() || 2, 10);
        widgetData.children = urlChildren || parseInt($('#children').val() || 0, 10);
        widgetData.guests = parseInt(widgetData.adults, 10) + parseInt(widgetData.children, 10);
        if (thn.parseUrlParameter('no-rooms')) {
            widgetData.noRooms = true;
        }
        else {
            const urlCurrency = thn.getCurrencyCode(thn.parseUrlParameter('currency'));
            const prices = $('.js-price-value').map((idx, el) => thn.parseNumber($(el).text()));
            widgetData.price = Math.min(...prices);
            widgetData.currency = urlCurrency || 'EUR';
            widgetData.set = true;
        }
        return widgetData;
    };
    /**
       * @memberOf module:bs_228
       * @this thn.widgets.booking
       * @see {@link Booking#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.bookingParseData = function bookingParseData(ctx) {
        var widgetData = {};
        /* Booking ID */
        widgetData.bookingId = Math.round((new Date()).getTime() / 1000);
        /* Dates */
        let localThnInfo = window.localStorage && window.localStorage.thnInfo;
        if (localThnInfo) {
            localThnInfo = JSON.parse(localThnInfo);
            widgetData.dateBegin = localThnInfo.checkin && localThnInfo.checkin.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
            widgetData.dateEnd = localThnInfo.checkout && localThnInfo.checkout.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
        }
        /* Price & Currency */
        widgetData.price = 120;
        widgetData.currency = 'EUR';
        return widgetData;
    };
    /**
       * @memberOf module:bs_228
       * @this thn.widgets.price
       * @see {@link Price#get_promocode}
       *
       * @param {object} ctx - The context object.
       */
    engine.getPromocode = function getPromocode(ctx) {
        // EXAMPLE CODE
        // ctx.promocode = thn.parseUrlParameter('code') || (window.jQuery && jQuery('input[name=code]').val()) || "";
        return ctx.promocode;
    };
    return engine;
}

export { factory };
